export default __webpack_public_path__ + "static/media/7A0ECE58-B7A1-4D01-A0A8-4D2A998BB9A2.1b09846f.jpg";